<!-- 
    projectId?:string;
    organizationId?:string;
    fullname?:string;
    title:string;
    subtitle?:string;
    shortdescription?:string;
    projectdescription?:string;
    projectscope?:string;
    projectlocation?:string;
    customer:string;
    creator?:string;
    created?:Date;
    canedit?:boolean;
    start_date:Date;
    end_date:Date;
    progress:number;
    overduedays:number; -->
<div class="project-list" >
    <div *ngFor="let proj of projectlist">
        <div class="project" style="padding-left:5px; padding-right:5px;" (click)="navigate(proj)">
            <div class="row">
                <div class="col-auto pr-0">
                    <app-customerlogo [customerlistmode]="true" [enableChange]="false" [customerId]="proj.customer" style="height: 35px!important;"></app-customerlogo>
                </div>
                <div class="col" style="margin-left: 0px;">
                    <h6 class="h6">{{proj.title}}</h6>
                </div>
                <div class="col-">
                    <span class="material-icons float-right" style="margin-top:10px; padding-right:22px;">
                        chevron_right
                        </span>
                </div>
            </div>
        </div>
        <hr class="mt-0 mb-0" style="border-top-color: #f2f2f2!important;"/>
    </div>
</div>    

